import {
  InsuranceDTO,
} from 'dtos';
import isNil from 'lodash/isNil';

const inactiveClaimInsuranceTooltip = 'Insurance on this claim is inactive. Select an active insurance.';
const missingClaimInsuranceTooltip = 'This claim has no insurance. Select an active insurance.';

export type ClaimInsuranceValidity = {
  isMissing: boolean;
  isInactive: boolean;
  isInvalid: boolean;
  invalidTooltip: string;
};

export function getClaimInsuranceValidity(
  insurance?: Pick<InsuranceDTO, 'inactive'> | null,
  isLoading = false,
): ClaimInsuranceValidity {
  const isMissing = isNil(insurance);
  const isInactive = insurance?.inactive ?? false;

  return {
    isMissing,
    isInactive,
    isInvalid: !isLoading && (isMissing || isInactive),
    invalidTooltip: isInactive
      ? inactiveClaimInsuranceTooltip
      : missingClaimInsuranceTooltip,
  };
}
